import type { CameraMemo } from "~/entities/camera-memo/types";
import axiosInstance from "~/shared/api/axios-instance";

export type CameraMemoAction =
  | { actionType: "create"; data: Omit<CameraMemo, "id" | "updatedAt"> }
  | { actionType: "update"; data: CameraMemo }
  | { actionType: "delete"; data: CameraMemo };

export async function updateCameraMemos(
  branchUid: string,
  versionId: number | undefined,
  actions: CameraMemoAction[],
): Promise<void> {
  const payload = actions.map(({ actionType, data }) => {
    const base: Record<string, unknown> = {
      version: versionId,
      action_type: actionType,
      data: {
        ...(actionType !== "create" ? { id: (data as CameraMemo).id } : {}),
        type: data.type === "default" ? 0 : 1,
        content: data.content,
        pseudo_camera_orientation_id: data.cameraId,
        floor_plan_id: data.floorPlanId ?? null,
        floor_plan_coordinates: data.positionForFloorPlan ?? null,
      },
    };
    return base;
  });

  await axiosInstance.patch(`branches/${branchUid}/comments/`, payload);
}
